import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import CodeInput from "./mfaCode";
import customConfig from "../../config";
import QRdisplay from "./mfaQR";
import Dialog from "../Common/Dailog/Dailog";
import AppButton from "../Common/Button/Button";

const MfaQrCode = ({ qrCodeUrl, tenantData }) => {
  const [showInstructions, setShowInstructions] = useState(false);
  const [showCodes, setShowCodes] = useState(false);

  const closeInstructions = () => {
    setShowInstructions(false);
  };

  const handleContinue = () => {
    setShowCodes(true);
  };

  return (
    <Fragment>
      <div className="login-wrapper">
        <div className="login-box">
          <div className="form-box">
            <div className="row mb-0">
              <div className="col s12 center-align">
                {tenantData?.tenantLogoUrl && (
                  <img
                    src={tenantData.tenantLogoUrl}
                    alt="Logo"
                    className="logo-outer"
                    onError={(e) => {
                      e.currentTarget.style.display = "none";
                    }}
                  />
                )}
              </div>
            </div>

            <Dialog
              open={showInstructions}
              onClose={closeInstructions}
              maxWidth="sm"
              fullWidth
              showCloseButton
              closeOnBackdropClick
              closeOnEscapeKeyDown
              contentSx={{
                pt: 0,
                pb: 2,
                overflow: "visible",
              }}
              title={undefined}
              PaperProps={{
                sx: { borderRadius: 2, width: 680, maxWidth: "calc(100vw - 24px)" },
              }}
            >
              <div className="qr-popup-container" style={{ maxWidth: "100%" }}>
                <h2
                  style={{
                    overflow: "visible",
                    maxWidth: "100%",
                    fontSize: "clamp(20px, 5vw, 24px)",
                    lineHeight: 1.2,
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                  }}
                >
                  Set up 2-Step Authentication
                </h2>
                <ol>
                  {(customConfig.mfaSetupInstuctions || []).map((instruction, index) => (
                    <li key={index}>{instruction}</li>
                  ))}
                </ol>
              </div>
            </Dialog>

            {!showCodes ? (
              <>
                <QRdisplay />
                <AppButton
                  variant="primary"
                  size="large"
                  onClick={handleContinue}
                  fullWidth
                  sx={{
                    mt: 2,
                    height: 50,
                    fontSize: 17,
                    fontWeight: 600,
                    width: "100%",
                  }}
                >
                  Continue
                </AppButton>
              </>
            ) : (
              <CodeInput />
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

MfaQrCode.propTypes = {
  qrCodeUrl: PropTypes.string.isRequired,
  tenantData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  qrCodeUrl: state.auth.qrCodeUrl,
});

export default connect(mapStateToProps)(MfaQrCode);

